export default {
  'menu.manufacturer': 'Manufacturer Dashboard',
  'menu.manufacturer.openbrowser': 'Open Browser',
  'menu.manufacturer.metaxtv': 'MetaX TV',
  'menu.manufacturer.adsdk': 'Ad SDK',
  'menu.manufacturer.distributionPerf': 'MetaX Platform',
  'menu.manufacturer.distributionThirdParty': 'Third Party Platform',

  'menu.operator': 'Operator Dashboard',
  'menu.operator.openbrowser': 'Open Browser',
  'menu.operator.metaxtv': 'MetaX TV',
  'menu.operator.adsdk': 'Ad SDK',
  'menu.operator.distributionPerf': 'MetaX Platform',
  'menu.operator.distributionThirdParty': 'Third Party Platform',
  
  'menu.cp': 'CP Dashboard',
  'menu.cp.openbrowser': 'Open Browser',
  'menu.cp.metaxtv': 'MetaX TV',
  'menu.cp.adsdk': 'Ad SDK',
  'menu.cp.distributionPerf': 'MetaX Platform',
  'menu.cp.distributionThirdParty': 'Third Party Platform',
  
  'menu.resellers': 'Resellers Dashboard',
  'menu.resellers.openbrowser': 'Open Browser',
  'menu.resellers.metaxtv': 'MetaX TV',
  'menu.resellers.adsdk': 'Ad SDK',
  'menu.resellers.distributionPerf': 'MetaX Platform',
  'menu.resellers.distributionThirdParty': 'Third Party Platform',

  'menu.report': 'Report',
  'menu.report.metaxtv': 'MetaX TV',
  'menu.report.openbrowser': 'Open Browser',
  'menu.report.distribution': 'MetaX Platform',
  'menu.report.thirdPartyDistribution': 'Third Party Platform',
  'menu.report.adsdk': 'Ad SDK',

  'menu.setting' : 'Settings',
  'menu.setting.account': 'Account setting',
  'menu.setting.access': 'Access & Authorization',
  'menu.setting.reportApi': 'Report API',

  'menu.admin': 'Admin',
  'menu.admin.global': 'Global Setting',
  'menu.admin.partner-bind': 'Partner Bind',
  'menu.admin.account': 'Account',
  'menu.admin.access': 'Access',
  'menu.admin.team': 'Team',
  'menu.admin.company': 'Company',
  'menu.admin.permissions': 'Permissions',
  'menu.admin.role': 'Role',

  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.update-password': 'Update Password',
  'menu.reset-password': 'Reset Password',
  'menu.forgot-password': 'Forgot Password',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
